import * as $ from 'jquery';
import Swal from 'sweetalert2';

export default (function () {
    Swal.mixin({ 
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: 'null',
        cancelButtonColor: 'null',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-primary',
    });

    // Export swal to window
    window.Swal = Swal;

    $(document).on('click', "form.delete button", function(e) {
        var $this = $(e.currentTarget);
        e.preventDefault();

        Swal.fire({
            title: 'Atenção!',
            html: ($this.attr('swal-html') != undefined) ? $this.attr('swal-html') : 'Tem certeza que deseja realizar esta ação?',
            type: 'warning',
            showCancelButton: true,
        }).then(res => {
            if (res.value) {
                $this.closest("form").submit();
            }
        });
    });
}())
